//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Shipment from '~/api/entities/shipment';
import { getTrackingDateValue } from '~/api/entities/shipment/tracking';

export default {
  name: 'shipment-tracking-progress',
  props: {
    shipment: {
      type: Shipment,
      required: true,
    },
  },
  computed: {
    locale () {
      return String(this.$i18n?.locale || this.$locale || 'ru').startsWith('en')
        ? 'en-US'
        : 'ru-RU';
    },
    title () {
      return this.$t('cabinet.tracking.title');
    },
    statusTitle () {
      const status = this.shipment.trackingStatus;
      return status ? this.$t(`cabinet.tracking.statuses.${status}`) : '';
    },
    timeline () {
      // Locale is an explicit dependency for recalculating localized entity getters.
      const locale = this.locale;
      return locale ? this.shipment.trackingTimeline : [];
    },
    progress () {
      return Math.max(0, Math.min(100, Number(this.shipment.trackingProgress) || 0));
    },
    updatedLabel () {
      return this.$t('cabinet.tracking.updatedToday', { time: this.formatTime(new Date()) });
    },
  },
  methods: {
    shouldConnectToNext (index) {
      const nextState = this.timeline[index + 1]?.state;
      return ['completed', 'current', 'warning'].includes(nextState);
    },
    dateParts (value) {
      const timestamp = getTrackingDateValue(value);
      return timestamp ? new Date(timestamp) : null;
    },
    formatTime (date) {
      return new Intl.DateTimeFormat(this.locale, {
        hour: '2-digit',
        minute: '2-digit',
      }).format(date);
    },
    formatDate (value) {
      const date = this.dateParts(value);
      if (!date) return '';
      const currentYear = new Date().getFullYear();
      const options = {
        day: 'numeric',
        month: 'long',
        hour: '2-digit',
        minute: '2-digit',
      };
      if (date.getFullYear() !== currentYear) options.year = 'numeric';
      return new Intl.DateTimeFormat(this.locale, options)
        .format(date)
        .replace(',', ',');
    },
    displayedDate (item) {
      if (item.datetime) return this.formatDate(item.datetime);
      if (item.estimatedDatetime) return `~ ${this.formatDate(item.estimatedDatetime)}`;
      return '';
    },
    partialLabel (item) {
      const pieces = item.movement?.cargo?.pieces;
      const total = this.shipment.cargo?.pieces;
      return this.$t('cabinet.tracking.partial', {
        pieces,
        total,
      });
    },
  },
};
